import { styled } from '@mui/material/styles';

export const StyledChatInitialStateContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  flexGrow: 1,
  padding: theme.spacing(4, 3, 2),
  marginBottom: theme.spacing(5),
  gap: theme.spacing(2),
}));
